import { Box, Icon } from '@chakra-ui/react';
import { FaInfoCircle } from '@react-icons/all-files/fa/FaInfoCircle';
import { ReactNode } from 'react';

import Popover, { PopoverProps } from '../../../../components/Popover';

type InfoPopoverIconProps = {
  label: ReactNode;
  ariaLabel: string;
  color?: string;
  boxSize?: string;
  popoverContentProps?: PopoverProps['popoverContentProps'];
};

const InfoPopoverIcon = ({
  label,
  ariaLabel,
  color = 'gray.400',
  boxSize = '13px',
  popoverContentProps,
}: InfoPopoverIconProps) => (
  <Popover label={label} placement="top" popoverContentProps={popoverContentProps}>
    <Box as="button" type="button" lineHeight={0} aria-label={ariaLabel}>
      <Icon as={FaInfoCircle} color={color} boxSize={boxSize} />
    </Box>
  </Popover>
);

export default InfoPopoverIcon;
